var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",attrs:{"id":"ALLPOWER","name":"ALLPOWER","data-vcode":"POWER","disabled":"","aria-label":`${_vm.$t('allPower')}`}},[_c('img',{attrs:{"src":"/images/icons/power.svg","alt":""}}),_c('label',{attrs:{"aria-hidden":"true"}},[_vm._v(_vm._s(_vm.$t('allPower')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }